module.exports = __webpack_public_path__ + "static/0090-b5d5adb7e9c932ff00a468fdda84cd01.png";